export default __webpack_public_path__ + "static/media/546.f3ade826.jpg";